<mat-icon [svgIcon]="iconName"></mat-icon>